// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topBox{
    padding: 0 !important;
    /* overflow-x: hidden; */
}
.top-orange-box{
    background-color: #FDF5F2;
    height: 150px;
}
.main-content-part.topBox .innerInfo{
    padding: 0px 70px 0px 35px;
    margin-top: -80px;
}
.main-content-part.topBox .innerInfo.withoutOrange{
    margin-top: 20px;
}
.doctorDetailsCard{
   border-radius: 14px;
   background-color: #fff;
    /* box-shadow: 0px 1px 15px #0000000f; */
   display: flex;
   flex-direction: column;
   align-items: center;
   padding: 35px 40px;
}
.doctorDetailsCard .doctorContent{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.doctorDetailsCard .doctorContent .imnage-part{
    text-align: center;
}
.doctorDetailsCard .doctorContent .rating{
    width: auto;
    display: flex;
    justify-content: center;
    margin-top: -40px;
}
.doctorDetailsCard .doctorContent .rating p{
    font-size: 16px;
    margin-bottom: 0;
    background-color: #FEF9E6;
    padding: 12px 24px;
    border-radius: 8px;
}
.doctorDetailsCard .doctorContent .doctorInfo{
    text-align: center;
    margin-top: 10px;
}
.doctorDetailsCard .doctorContent .doctorInfo h4{
    font-weight: 500;
    font-size: 14px;
}
.doctorDetailsCard .doctorContent .doctorInfo h5{
    font-size: 14px;
    font-weight: 400;
    color: #FF6036;
}
.doctorDetailsCard .doctorContent .doctorInfo h6{
    font-size: 14px;
    font-weight: 400;
}
.doctorDetailsCard .doctorContent .logInfo{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 8px;
}
.doctorDetailsCard .doctorContent .logInfo .badge{
    width: 68px;
    height: 42px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.doctorDetailsCard .doctorContent .logInfo .badge.call{
    background-color: #DBF9EA;
}
.doctorDetailsCard .doctorContent .logInfo .badge.email{
    background-color: #FDF5F2;
}
.doctorDetailsCard .doctorContent .expData{
    margin: 35px 0px;
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.doctorDetailsCard .doctorContent .expData .part{
    text-align: center;
    border-right: 1px solid #EAEAEA;
    flex: 1 1;
}
.doctorDetailsCard .doctorContent .expData .part:last-child{
    border-right: 0;
}
.doctorDetailsCard .doctorContent .expData .part h6{
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    margin-bottom: 0;
    margin-top: 4px;
}
.doctorDetailsCard .doctorContent .expData .part p{
    font-size: 14px;
    font-weight: 400;
    color: #ADADAD;
    margin-bottom: 0;
}
.doctorDetailsCard .doctorContent  .aboutInfo h6{
    font-size: 16px;
    font-weight: 500;
}   
.doctorDetailsCard .doctorContent .aboutInfo p{
    font-size: 14px;
    font-weight: 400;
    color: #ADADAD;
}   
.rightSmallCard{
    text-align: center;
}
.rightSmallCard h6{
    font-size: 26px;
    font-weight: 600;
}
.rightSmallCard p{
    font-size: 16px;
    color: #ADADAD;
    margin-bottom: 0;
}
/* common */
.doctorDetailsCard.startdata{
    align-items: flex-start;
    padding: 0;
}
.doctorDetailsCard.startdata .rightPartData{
    width: 100%;
}
.doctorDetailsCard.startdata .rightPartData .filed{
    border-bottom: 1px solid #EAEAEA;
    padding-bottom: 10px;
    padding-top: 20px;
    margin: 0 40px;
}
.doctorDetailsCard.startdata .rightPartData .filed:last-child{
    border-bottom: 0;
    padding-bottom: 30px;
}
.doctorDetailsCard .rightPartData  .filed h6{
    font-size: 14px;
    font-weight: 500;
}
.doctorDetailsCard .rightPartData  .filed h5{
    font-size: 14px;
    font-weight: 600;
}
.doctorDetailsCard .rightPartData .locationTimeField{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.doctorDetailsCard .rightPartData p{
    margin-bottom: 0;
    font-size: 14px;
    line-height: 20px;
}
.doctorDetailsCard .rightPartData p span{
    color: #12D372;
}
.doctorDetailsCard .rightPartData .no-slot{
    font-size: 16px;
    color: #ADADAD;
    margin-top: 10px;
    margin-bottom: 0;
}
.doctorDetailsCard .rightPartData  p.badge{
    font-size: 12px;
    background-color: #12D3720f;
    border-radius: 7px;
    color: #12D372;
    padding: 4px 12px;
}

.doctorDetailsCard .bottom-part{
    background-color: #FDF5F2;
    width: 100%;
    text-align: center;
    padding: 20px 0;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;
}
.doctorDetailsCard .bottom-part a{
    color: #FF6036;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
}


/* radio badge part */
.radio-badge-part{
    margin-top: 15px;
}
.radio-badge-part form {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}
.radio-badge-part label {
    display: flex;
    cursor: pointer;
    font-size: 12px;
    font-weight: 400;
    position: relative;
    overflow: hidden;
    text-align: center;
}
.radio-badge-part label input {
    position: absolute;
    left: -9999px;
}
.radio-badge-part label input:checked + span {
    background-color: #FF6036;
    border: 1px solid #FF6036;
    color: #fff;
}
.radio-badge-part label input:checked + span:before {
    box-shadow: inset 0 0 0 0.4375em #00005c;
}
.radio-badge-part label span {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 12px;
    border-radius: 99em;
    transition: 0.25s ease;
    border: 1px solid #EAEAEA;
    width: 80px;
    text-align: center;
}
.radio-badge-part label span:hover {
    background-color: #FF6036;
    border: 1px solid #FF6036;
    color: #fff;
}

.radio-badge-outline  label span{
    width: auto;
    min-width: 80px;
}
.radio-badge-part.radio-badge-outline label input:checked + span {
    background-color: transparent;
    border: 1px solid #FF6036;
    color: #FF6036;
}
.radio-badge-part.radio-badge-outline label span:hover {
    background-color: transparent;
    border: 1px solid #FF6036;
    color: #FF6036;
}
.radio-badge-outline label{
    font-size: 12px !important;
    font-weight: 400 !important;
}


.border_shradded {
    /* background-image: linear-gradient(rgba(0, 200, 255, 0.507), rgba(0, 200, 255, 0.699)); */
    /* background: radial-gradient(closest-side, #3f87a6, #ebf8e1, #3ce0f6); */
    border-color: #ffefe9;
    border-style: solid;
    border-width: 8px;

}


.DayPicker-Day.upcoming {
    background-color: #FF6036; /* Change this to the desired background color */
    color: #fff; /* Change this to the desired text color */
  }
  
  /* Style for completed dates */
  .DayPicker-Day.completed {
    background-color: #00FF00; /* Change this to the desired background color */
    color: #fff; /* Change this to the desired text color */
  }
  
  .complete-modal .workout-desc p {
    width: 55%;
    margin: 0 auto;
    text-align: center;
    font-size: 26px;
    line-height: 30px;
    margin-bottom: 15px;
}
.workout-reps {
    font-size: 20px;
    color: #23bee3;
    margin-bottom: 10px;
}
.complete-modal .workout-desc .modal-text {
    font-size: 16px;
    color: #adadad;
    line-height: 21px;
    width: 75%;
    margin: 0 auto 20px;
    text-align: center;
}


/*  Ruchi started : for the patient details page */


.main-box {
    padding-right: 35px;
    padding-left: 35px;
    /* margin-left: 5rem;
    margin-right: 5rem; */
    background: white;
    border-radius: 14px;
    box-shadow: 0px 0px 100px rgba(0, 0, 0, 0.06);
  }
  
  .card-box {
    display: flex;
    /* justify-content: space-evenly; */
    align-items: center;
    padding-top: 26.5px;
    padding-bottom: 22.5px;
    border-bottom: 1px solid #eaeaea;
  }
  .profile-image-container {
    width: 165px;
    height: 163px;
    padding: 4px;
    background-color: white;
  border-radius: 50%;
  box-shadow: 0 4px 20px rgba(255, 96, 54, 0.5); /* Rounded shadow */

  }
  .profile-content {
    display: flex;
    flex-direction: column;
    padding-bottom: 11px;
    margin-left: 18.5px;
  }
  .heading {
    display: flex;
    justify-content: space-between;
  }
  .user-name {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  .name-tag-text-style {
    margin: 0;
    font: 500 26px Poppins, sans-serif;
    color: #1d2432;
  }
  .edit-label {
    margin: 0;
    font: 400 12px Poppins, sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 49px;
    height: 26px;
    cursor: pointer;
    border: 1px solid #eaeaea;
    border-radius: 6px;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.16);
  }
  .action-button {
    min-width: 80px;
    height: 35px;
    font: 500 14px Poppins, sans-serif;
    color: white;
    cursor: pointer;
    background: #f16238;
    border: none;
    border-radius: 8px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  }
  .contact-info-section {
    display: flex;
    gap: 15px;
    justify-content: flex-start;
    margin-top: 10px;
  }
  .contact-info-text {
    margin: 0;
    font: 400 12px Poppins, sans-serif;
    color: #adadad;
  }
  
  .injury-exercise-container {
    display: flex;
    height: 60px;
    margin-top: 15px;
  }
  .injury-info-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 14px;
    border: 1px solid #eaeaea;
    border-radius: 6px;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.16);
  }
  .injured-body-part-text-style {
    font: 400 12px Poppins, sans-serif;
  }
  .injury-description {
    margin-top: -7px;
    font: 500 16px Poppins, sans-serif;
  }
  .exercise-progress-container {
    display: flex;
    flex-direction: column;
    padding-right: 15px;
    padding-left: 15px;
    margin-left: 12px;
    border: 1px solid #eaeaea;
    border-radius: 6px;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.16);
  }
  .progress-indicator-container {
    display: flex;
    justify-content: space-between;
  }
  .exercise-progress-bar {
    display: flex;
    background: #fdf5f2;
    border-radius: 14px;
  }
  .coral-button {
    width: 130px;
    height: 11px;
    background: #ff6036;
    border-radius: 14px;
  }
  .horizontal-box {
    width: 384px;
    height: 11px;
  }
  .horizontal-nav-list {
    display: flex;
    gap: 38px;
    align-items: center;
    width: 100%;
    height: 49px;
  }
  .workout-history-text-style {
    font: 400 16px Poppins, sans-serif;
    color: #f16238;
    border-bottom: 1px solid black;
  }
  
  .tab-text {
    font: 400 15px Poppins, sans-serif;
    color: #aaa; /* Default color for inactive tabs */
    cursor: pointer;
    padding: 13px 20px;
    margin-bottom: 0px;
  }
  
  .tab-text.active {
    color: #f16238; /* Orange color for the active tab */
    font-weight: 400;
    border-bottom: 2px solid #f16238; /* Orange underline for the active tab */
  }
  
  .tab-text:hover {
    color: #555; /* Hover effect for inactive tabs */
  }
  
  @media screen and (max-width: 1024px) {
  }
  
  @media screen and (max-width: 991px) {
  }
  
  @media screen and (max-width: 768px) {
  }
  
  @media screen and (max-width: 574px) {
    .profile-content {
      margin-left: 0px;
    }
    .heading {
      justify-content: center;
      gap: 10px;
    }
    .contact-info-section {
      display: block;
    }
    .card-box {
      display: block;
      text-align: center;
    }
    .injury-exercise-container {
      display: block;
      height: 150px;
    }
    .horizontal-nav-list {
      display: block;
    }
    .exercise-progress-container {
      margin-left: 0px;
      height: 65px;
      margin-top: 20px;
    }
    .injury-info-container {
      padding: 0px;
    }
    .main-box{
      padding-right: 17px;
      padding-left: 17px;
    }
    .name-tag-text-style{
      font-size: 16px;
    }
    .action-button{
      height: 30px;
      font-size: 14px;
    }
    .contact-info-text{
      margin-top: 10px;
    }
    .user-name{
      align-items: center;
    }
  }
  /*  Ruchi Ended : for the patient details page */


  .overviewTabExercise {
    box-shadow: none !important;
    border-radius: 0px !important;
    border-top: 1px solid #e9ecef;
    margin: 10px;
    padding-left:0px ;
    padding-right:0px;
  }
  .arrow-icon {
    border:1px solid #dddddd;
    color: #ff6036;
    height: 30px;
    align-items: center;
    display: flex;
    justify-content: center;
    width: 30px;
    border-radius: 6px;
    box-shadow: 0px 4px 5px rgba(255, 96, 54, 0.2); /* Adjust the shadow values as needed */
  }`, "",{"version":3,"sources":["webpack://./src/assets/css/doctorInfo.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;AACA;IACI,yBAAyB;IACzB,aAAa;AACjB;AACA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;GACG,mBAAmB;GACnB,sBAAsB;IACrB,wCAAwC;GACzC,aAAa;GACb,sBAAsB;GACtB,mBAAmB;GACnB,kBAAkB;AACrB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,SAAO;AACX;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA,WAAW;AACX;IACI,uBAAuB;IACvB,UAAU;AACd;AACA;IACI,WAAW;AACf;AACA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,+BAA+B;IAC/B,gCAAgC;AACpC;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;;AAGA,qBAAqB;AACrB;IACI,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,eAAe;IACf,SAAS;AACb;AACA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,0BAA0B;IAC1B,2BAA2B;AAC/B;;;AAGA;IACI,2FAA2F;IAC3F,0EAA0E;IAC1E,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;;AAErB;;;AAGA;IACI,yBAAyB,EAAE,gDAAgD;IAC3E,WAAW,EAAE,0CAA0C;EACzD;;EAEA,8BAA8B;EAC9B;IACE,yBAAyB,EAAE,gDAAgD;IAC3E,WAAW,EAAE,0CAA0C;EACzD;;EAEA;IACE,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA,kDAAkD;;;AAGlD;IACI,mBAAmB;IACnB,kBAAkB;IAClB;yBACqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,mCAAmC;IACnC,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;EAClC;EACA;IACE,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,uBAAuB;EACzB,kBAAkB;EAClB,6CAA6C,EAAE,mBAAmB;;EAElE;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;EACA;IACE,SAAS;IACT,kCAAkC;IAClC,cAAc;EAChB;EACA;IACE,SAAS;IACT,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,2CAA2C;EAC7C;EACA;IACE,eAAe;IACf,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;EAC7C;EACA;IACE,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,SAAS;IACT,kCAAkC;IAClC,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,2CAA2C;EAC7C;EACA;IACE,kCAAkC;EACpC;EACA;IACE,gBAAgB;IAChB,kCAAkC;EACpC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,2CAA2C;EAC7C;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,WAAW;IACX,YAAY;EACd;EACA;IACE,kCAAkC;IAClC,cAAc;IACd,8BAA8B;EAChC;;EAEA;IACE,kCAAkC;IAClC,WAAW,EAAE,oCAAoC;IACjD,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,cAAc,EAAE,oCAAoC;IACpD,gBAAgB;IAChB,gCAAgC,EAAE,wCAAwC;EAC5E;;EAEA;IACE,WAAW,EAAE,mCAAmC;EAClD;;EAEA;EACA;;EAEA;EACA;;EAEA;EACA;;EAEA;IACE;MACE,gBAAgB;IAClB;IACA;MACE,uBAAuB;MACvB,SAAS;IACX;IACA;MACE,cAAc;IAChB;IACA;MACE,cAAc;MACd,kBAAkB;IACpB;IACA;MACE,cAAc;MACd,aAAa;IACf;IACA;MACE,cAAc;IAChB;IACA;MACE,gBAAgB;MAChB,YAAY;MACZ,gBAAgB;IAClB;IACA;MACE,YAAY;IACd;IACA;MACE,mBAAmB;MACnB,kBAAkB;IACpB;IACA;MACE,eAAe;IACjB;IACA;MACE,YAAY;MACZ,eAAe;IACjB;IACA;MACE,gBAAgB;IAClB;IACA;MACE,mBAAmB;IACrB;EACF;EACA,gDAAgD;;;EAGhD;IACE,2BAA2B;IAC3B,6BAA6B;IAC7B,6BAA6B;IAC7B,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,wBAAwB;IACxB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,8CAA8C,EAAE,uCAAuC;EACzF","sourcesContent":[".topBox{\r\n    padding: 0 !important;\r\n    /* overflow-x: hidden; */\r\n}\r\n.top-orange-box{\r\n    background-color: #FDF5F2;\r\n    height: 150px;\r\n}\r\n.main-content-part.topBox .innerInfo{\r\n    padding: 0px 70px 0px 35px;\r\n    margin-top: -80px;\r\n}\r\n.main-content-part.topBox .innerInfo.withoutOrange{\r\n    margin-top: 20px;\r\n}\r\n.doctorDetailsCard{\r\n   border-radius: 14px;\r\n   background-color: #fff;\r\n    /* box-shadow: 0px 1px 15px #0000000f; */\r\n   display: flex;\r\n   flex-direction: column;\r\n   align-items: center;\r\n   padding: 35px 40px;\r\n}\r\n.doctorDetailsCard .doctorContent{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.doctorDetailsCard .doctorContent .imnage-part{\r\n    text-align: center;\r\n}\r\n.doctorDetailsCard .doctorContent .rating{\r\n    width: auto;\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-top: -40px;\r\n}\r\n.doctorDetailsCard .doctorContent .rating p{\r\n    font-size: 16px;\r\n    margin-bottom: 0;\r\n    background-color: #FEF9E6;\r\n    padding: 12px 24px;\r\n    border-radius: 8px;\r\n}\r\n.doctorDetailsCard .doctorContent .doctorInfo{\r\n    text-align: center;\r\n    margin-top: 10px;\r\n}\r\n.doctorDetailsCard .doctorContent .doctorInfo h4{\r\n    font-weight: 500;\r\n    font-size: 14px;\r\n}\r\n.doctorDetailsCard .doctorContent .doctorInfo h5{\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    color: #FF6036;\r\n}\r\n.doctorDetailsCard .doctorContent .doctorInfo h6{\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n}\r\n.doctorDetailsCard .doctorContent .logInfo{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 10px;\r\n    margin-top: 8px;\r\n}\r\n.doctorDetailsCard .doctorContent .logInfo .badge{\r\n    width: 68px;\r\n    height: 42px;\r\n    border-radius: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.doctorDetailsCard .doctorContent .logInfo .badge.call{\r\n    background-color: #DBF9EA;\r\n}\r\n.doctorDetailsCard .doctorContent .logInfo .badge.email{\r\n    background-color: #FDF5F2;\r\n}\r\n.doctorDetailsCard .doctorContent .expData{\r\n    margin: 35px 0px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n}\r\n.doctorDetailsCard .doctorContent .expData .part{\r\n    text-align: center;\r\n    border-right: 1px solid #EAEAEA;\r\n    flex: 1;\r\n}\r\n.doctorDetailsCard .doctorContent .expData .part:last-child{\r\n    border-right: 0;\r\n}\r\n.doctorDetailsCard .doctorContent .expData .part h6{\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    line-height: 20px;\r\n    margin-bottom: 0;\r\n    margin-top: 4px;\r\n}\r\n.doctorDetailsCard .doctorContent .expData .part p{\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    color: #ADADAD;\r\n    margin-bottom: 0;\r\n}\r\n.doctorDetailsCard .doctorContent  .aboutInfo h6{\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n}   \r\n.doctorDetailsCard .doctorContent .aboutInfo p{\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    color: #ADADAD;\r\n}   \r\n.rightSmallCard{\r\n    text-align: center;\r\n}\r\n.rightSmallCard h6{\r\n    font-size: 26px;\r\n    font-weight: 600;\r\n}\r\n.rightSmallCard p{\r\n    font-size: 16px;\r\n    color: #ADADAD;\r\n    margin-bottom: 0;\r\n}\r\n/* common */\r\n.doctorDetailsCard.startdata{\r\n    align-items: flex-start;\r\n    padding: 0;\r\n}\r\n.doctorDetailsCard.startdata .rightPartData{\r\n    width: 100%;\r\n}\r\n.doctorDetailsCard.startdata .rightPartData .filed{\r\n    border-bottom: 1px solid #EAEAEA;\r\n    padding-bottom: 10px;\r\n    padding-top: 20px;\r\n    margin: 0 40px;\r\n}\r\n.doctorDetailsCard.startdata .rightPartData .filed:last-child{\r\n    border-bottom: 0;\r\n    padding-bottom: 30px;\r\n}\r\n.doctorDetailsCard .rightPartData  .filed h6{\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n}\r\n.doctorDetailsCard .rightPartData  .filed h5{\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n}\r\n.doctorDetailsCard .rightPartData .locationTimeField{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n}\r\n.doctorDetailsCard .rightPartData p{\r\n    margin-bottom: 0;\r\n    font-size: 14px;\r\n    line-height: 20px;\r\n}\r\n.doctorDetailsCard .rightPartData p span{\r\n    color: #12D372;\r\n}\r\n.doctorDetailsCard .rightPartData .no-slot{\r\n    font-size: 16px;\r\n    color: #ADADAD;\r\n    margin-top: 10px;\r\n    margin-bottom: 0;\r\n}\r\n.doctorDetailsCard .rightPartData  p.badge{\r\n    font-size: 12px;\r\n    background-color: #12D3720f;\r\n    border-radius: 7px;\r\n    color: #12D372;\r\n    padding: 4px 12px;\r\n}\r\n\r\n.doctorDetailsCard .bottom-part{\r\n    background-color: #FDF5F2;\r\n    width: 100%;\r\n    text-align: center;\r\n    padding: 20px 0;\r\n    border-bottom-left-radius: 14px;\r\n    border-bottom-right-radius: 14px;\r\n}\r\n.doctorDetailsCard .bottom-part a{\r\n    color: #FF6036;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    text-decoration: none;\r\n}\r\n\r\n\r\n/* radio badge part */\r\n.radio-badge-part{\r\n    margin-top: 15px;\r\n}\r\n.radio-badge-part form {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    gap: 10px;\r\n}\r\n.radio-badge-part label {\r\n    display: flex;\r\n    cursor: pointer;\r\n    font-size: 12px;\r\n    font-weight: 400;\r\n    position: relative;\r\n    overflow: hidden;\r\n    text-align: center;\r\n}\r\n.radio-badge-part label input {\r\n    position: absolute;\r\n    left: -9999px;\r\n}\r\n.radio-badge-part label input:checked + span {\r\n    background-color: #FF6036;\r\n    border: 1px solid #FF6036;\r\n    color: #fff;\r\n}\r\n.radio-badge-part label input:checked + span:before {\r\n    box-shadow: inset 0 0 0 0.4375em #00005c;\r\n}\r\n.radio-badge-part label span {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    padding: 8px 12px;\r\n    border-radius: 99em;\r\n    transition: 0.25s ease;\r\n    border: 1px solid #EAEAEA;\r\n    width: 80px;\r\n    text-align: center;\r\n}\r\n.radio-badge-part label span:hover {\r\n    background-color: #FF6036;\r\n    border: 1px solid #FF6036;\r\n    color: #fff;\r\n}\r\n\r\n.radio-badge-outline  label span{\r\n    width: auto;\r\n    min-width: 80px;\r\n}\r\n.radio-badge-part.radio-badge-outline label input:checked + span {\r\n    background-color: transparent;\r\n    border: 1px solid #FF6036;\r\n    color: #FF6036;\r\n}\r\n.radio-badge-part.radio-badge-outline label span:hover {\r\n    background-color: transparent;\r\n    border: 1px solid #FF6036;\r\n    color: #FF6036;\r\n}\r\n.radio-badge-outline label{\r\n    font-size: 12px !important;\r\n    font-weight: 400 !important;\r\n}\r\n\r\n\r\n.border_shradded {\r\n    /* background-image: linear-gradient(rgba(0, 200, 255, 0.507), rgba(0, 200, 255, 0.699)); */\r\n    /* background: radial-gradient(closest-side, #3f87a6, #ebf8e1, #3ce0f6); */\r\n    border-color: #ffefe9;\r\n    border-style: solid;\r\n    border-width: 8px;\r\n\r\n}\r\n\r\n\r\n.DayPicker-Day.upcoming {\r\n    background-color: #FF6036; /* Change this to the desired background color */\r\n    color: #fff; /* Change this to the desired text color */\r\n  }\r\n  \r\n  /* Style for completed dates */\r\n  .DayPicker-Day.completed {\r\n    background-color: #00FF00; /* Change this to the desired background color */\r\n    color: #fff; /* Change this to the desired text color */\r\n  }\r\n  \r\n  .complete-modal .workout-desc p {\r\n    width: 55%;\r\n    margin: 0 auto;\r\n    text-align: center;\r\n    font-size: 26px;\r\n    line-height: 30px;\r\n    margin-bottom: 15px;\r\n}\r\n.workout-reps {\r\n    font-size: 20px;\r\n    color: #23bee3;\r\n    margin-bottom: 10px;\r\n}\r\n.complete-modal .workout-desc .modal-text {\r\n    font-size: 16px;\r\n    color: #adadad;\r\n    line-height: 21px;\r\n    width: 75%;\r\n    margin: 0 auto 20px;\r\n    text-align: center;\r\n}\r\n\r\n\r\n/*  Ruchi started : for the patient details page */\r\n\r\n\r\n.main-box {\r\n    padding-right: 35px;\r\n    padding-left: 35px;\r\n    /* margin-left: 5rem;\r\n    margin-right: 5rem; */\r\n    background: white;\r\n    border-radius: 14px;\r\n    box-shadow: 0px 0px 100px rgba(0, 0, 0, 0.06);\r\n  }\r\n  \r\n  .card-box {\r\n    display: flex;\r\n    /* justify-content: space-evenly; */\r\n    align-items: center;\r\n    padding-top: 26.5px;\r\n    padding-bottom: 22.5px;\r\n    border-bottom: 1px solid #eaeaea;\r\n  }\r\n  .profile-image-container {\r\n    width: 165px;\r\n    height: 163px;\r\n    padding: 4px;\r\n    background-color: white;\r\n  border-radius: 50%;\r\n  box-shadow: 0 4px 20px rgba(255, 96, 54, 0.5); /* Rounded shadow */\r\n\r\n  }\r\n  .profile-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding-bottom: 11px;\r\n    margin-left: 18.5px;\r\n  }\r\n  .heading {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  .user-name {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n  }\r\n  .name-tag-text-style {\r\n    margin: 0;\r\n    font: 500 26px Poppins, sans-serif;\r\n    color: #1d2432;\r\n  }\r\n  .edit-label {\r\n    margin: 0;\r\n    font: 400 12px Poppins, sans-serif;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 49px;\r\n    height: 26px;\r\n    cursor: pointer;\r\n    border: 1px solid #eaeaea;\r\n    border-radius: 6px;\r\n    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.16);\r\n  }\r\n  .action-button {\r\n    min-width: 80px;\r\n    height: 35px;\r\n    font: 500 14px Poppins, sans-serif;\r\n    color: white;\r\n    cursor: pointer;\r\n    background: #f16238;\r\n    border: none;\r\n    border-radius: 8px;\r\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  .contact-info-section {\r\n    display: flex;\r\n    gap: 15px;\r\n    justify-content: flex-start;\r\n    margin-top: 10px;\r\n  }\r\n  .contact-info-text {\r\n    margin: 0;\r\n    font: 400 12px Poppins, sans-serif;\r\n    color: #adadad;\r\n  }\r\n  \r\n  .injury-exercise-container {\r\n    display: flex;\r\n    height: 60px;\r\n    margin-top: 15px;\r\n  }\r\n  .injury-info-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    padding: 14px;\r\n    border: 1px solid #eaeaea;\r\n    border-radius: 6px;\r\n    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.16);\r\n  }\r\n  .injured-body-part-text-style {\r\n    font: 400 12px Poppins, sans-serif;\r\n  }\r\n  .injury-description {\r\n    margin-top: -7px;\r\n    font: 500 16px Poppins, sans-serif;\r\n  }\r\n  .exercise-progress-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    padding-right: 15px;\r\n    padding-left: 15px;\r\n    margin-left: 12px;\r\n    border: 1px solid #eaeaea;\r\n    border-radius: 6px;\r\n    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.16);\r\n  }\r\n  .progress-indicator-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  .exercise-progress-bar {\r\n    display: flex;\r\n    background: #fdf5f2;\r\n    border-radius: 14px;\r\n  }\r\n  .coral-button {\r\n    width: 130px;\r\n    height: 11px;\r\n    background: #ff6036;\r\n    border-radius: 14px;\r\n  }\r\n  .horizontal-box {\r\n    width: 384px;\r\n    height: 11px;\r\n  }\r\n  .horizontal-nav-list {\r\n    display: flex;\r\n    gap: 38px;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 49px;\r\n  }\r\n  .workout-history-text-style {\r\n    font: 400 16px Poppins, sans-serif;\r\n    color: #f16238;\r\n    border-bottom: 1px solid black;\r\n  }\r\n  \r\n  .tab-text {\r\n    font: 400 15px Poppins, sans-serif;\r\n    color: #aaa; /* Default color for inactive tabs */\r\n    cursor: pointer;\r\n    padding: 13px 20px;\r\n    margin-bottom: 0px;\r\n  }\r\n  \r\n  .tab-text.active {\r\n    color: #f16238; /* Orange color for the active tab */\r\n    font-weight: 400;\r\n    border-bottom: 2px solid #f16238; /* Orange underline for the active tab */\r\n  }\r\n  \r\n  .tab-text:hover {\r\n    color: #555; /* Hover effect for inactive tabs */\r\n  }\r\n  \r\n  @media screen and (max-width: 1024px) {\r\n  }\r\n  \r\n  @media screen and (max-width: 991px) {\r\n  }\r\n  \r\n  @media screen and (max-width: 768px) {\r\n  }\r\n  \r\n  @media screen and (max-width: 574px) {\r\n    .profile-content {\r\n      margin-left: 0px;\r\n    }\r\n    .heading {\r\n      justify-content: center;\r\n      gap: 10px;\r\n    }\r\n    .contact-info-section {\r\n      display: block;\r\n    }\r\n    .card-box {\r\n      display: block;\r\n      text-align: center;\r\n    }\r\n    .injury-exercise-container {\r\n      display: block;\r\n      height: 150px;\r\n    }\r\n    .horizontal-nav-list {\r\n      display: block;\r\n    }\r\n    .exercise-progress-container {\r\n      margin-left: 0px;\r\n      height: 65px;\r\n      margin-top: 20px;\r\n    }\r\n    .injury-info-container {\r\n      padding: 0px;\r\n    }\r\n    .main-box{\r\n      padding-right: 17px;\r\n      padding-left: 17px;\r\n    }\r\n    .name-tag-text-style{\r\n      font-size: 16px;\r\n    }\r\n    .action-button{\r\n      height: 30px;\r\n      font-size: 14px;\r\n    }\r\n    .contact-info-text{\r\n      margin-top: 10px;\r\n    }\r\n    .user-name{\r\n      align-items: center;\r\n    }\r\n  }\r\n  /*  Ruchi Ended : for the patient details page */\r\n\r\n\r\n  .overviewTabExercise {\r\n    box-shadow: none !important;\r\n    border-radius: 0px !important;\r\n    border-top: 1px solid #e9ecef;\r\n    margin: 10px;\r\n    padding-left:0px ;\r\n    padding-right:0px;\r\n  }\r\n  .arrow-icon {\r\n    border:1px solid #dddddd;\r\n    color: #ff6036;\r\n    height: 30px;\r\n    align-items: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 30px;\r\n    border-radius: 6px;\r\n    box-shadow: 0px 4px 5px rgba(255, 96, 54, 0.2); /* Adjust the shadow values as needed */\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
